import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { connect } from 'react-redux';
import { MenuInfo } from 'rc-menu/lib/interface';
import ActionsMenuComponent, { Actions } from 'components/actions-menu/actions-reference-menu';
import { CombinedState } from 'reducers';

import { modelsActions } from 'actions/models-actions';
import { deleteReferenceAsync, switchMoveReferenceModalVisible, modelReferenceAsync } from 'actions/references-actions';
import { exportActions } from 'actions/export-actions';
import { importActions } from 'actions/import-actions';

interface OwnProps {
    referenceInstance: any;
    onViewAnalytics: () => void;
}

interface StateToProps {
    annotationFormats: any;
    inferenceIsActive: boolean;
    backupIsActive: boolean;
}

interface DispatchToProps {
    showExportModal: (referenceInstance: any, resource: 'dataset' | 'backup') => void;
    showImportModal: (referenceInstance: any, isReference?: boolean) => void;
    openRunModelWindow: (referenceInstance: any) => void;
    deleteReference: (referenceInstance: any) => void;
    modelReference: (referenceInstance: any) => void;
    openMoveReferenceToProjectWindow: (referenceId: number) => void;
}

function mapStateToProps(state: CombinedState, own: OwnProps): StateToProps {
    const {
        referenceInstance: { id: tid },
    } = own;

    const {
        formats: { annotationFormats },
    } = state;

    return {
        annotationFormats,
        inferenceIsActive: tid in state.models.inferencesRef,
        backupIsActive: state.export.references.backup.current[tid],
    };
}

function mapDispatchToProps(dispatch: any): DispatchToProps {
    return {
        showExportModal: (referenceInstance: any, resource: 'dataset' | 'backup'): void => {
            if (resource === 'dataset') {
                dispatch(exportActions.openExportDatasetModal(referenceInstance));
            } else {
                dispatch(exportActions.openExportBackupModal(referenceInstance));
            }
        },
        showImportModal: (referenceInstance: any, isReference = false): void => {
            dispatch(importActions.openImportDatasetModal(referenceInstance, isReference));
        },
        deleteReference: (referenceInstance: any): void => {
            dispatch(deleteReferenceAsync(referenceInstance));
        },
        modelReference: (referenceInstance: any): void => {
            dispatch(modelReferenceAsync(referenceInstance));
        },
        openRunModelWindow: (referenceInstance: any): void => {
            dispatch(modelsActions.showRunModelDialogRef(referenceInstance));
        },
        openMoveReferenceToProjectWindow: (referenceId: number): void => {
            dispatch(switchMoveReferenceModalVisible(true, referenceId));
        },
    };
}

function ActionsMenuContainer(props: OwnProps & StateToProps & DispatchToProps): JSX.Element {
    const {
        referenceInstance,
        annotationFormats: { loaders, dumpers },
        inferenceIsActive,
        backupIsActive,
        showExportModal,
        showImportModal,
        deleteReference,
        modelReference,
        openRunModelWindow,
        openMoveReferenceToProjectWindow,
        onViewAnalytics,
    } = props;

    const onClickMenu = (params: MenuInfo): void => {
        const [action] = params.keyPath;
        if (action === Actions.EXPORT_REFERENCE_DATASET) {
            showExportModal(referenceInstance, 'dataset');
        } else if (action === Actions.DELETE_REFERENCE) {
            deleteReference(referenceInstance);
        } else if (action === Actions.OPEN_BUG_TRACKER) {
            window.open(referenceInstance.bugTracker, '_blank');
        } else if (action === Actions.RUN_AUTO_ANNOTATION) {
            openRunModelWindow(referenceInstance);
        } else if (action === Actions.MODEL_REFERENCE) {
            modelReference(referenceInstance);
        } else if (action === Actions.BACKUP_REFERENCE) {
            showExportModal(referenceInstance, 'backup');
        } else if (action === Actions.MOVE_REFERENCE_TO_PROJECT) {
            openMoveReferenceToProjectWindow(referenceInstance.id);
        } else if (action === Actions.LOAD_REFERENCE_ANNO) {
            showImportModal(referenceInstance);
        } else if (action === Actions.VIEW_ANALYTICS) {
            onViewAnalytics();
        }
    };

    return (
        <ActionsMenuComponent
            referenceID={referenceInstance.id}
            projectID={referenceInstance.projectId}
            referenceMode={referenceInstance.mode}
            bugTracker={referenceInstance.bugTracker}
            loaders={loaders}
            dumpers={dumpers}
            inferenceIsActive={inferenceIsActive}
            onClickMenu={onClickMenu}
            referenceDimension={referenceInstance.dimension}
            backupIsActive={backupIsActive}
        />
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionsMenuContainer);

